export class DeviceMetadata {
	deviceId: string;
	parentId: string;
	deviceName: string;
	deviceType: string;
	locationId: string;
	properties: any;
	structureId: string;
	structureName: string;
	zoneId: string;
	zoneName: string;
}

